import { CustomerType } from '@/entities/customer-type';
import { useFeatureFlag } from '@/hooks/use-feature-flag';
import { useMe } from '@/hooks/use-me';

import { ManualNews } from './manual-news';
import { NewAlerts } from './new-alerts';
import { NewReports } from './new-reports';

export function WhatsNew() {
  const featureFlag = useFeatureFlag();
  const me = useMe();

  return (
    <div className="space-y-6 text-base text-gray-600">
      {featureFlag('alerts') ? <NewAlerts /> : null}
      <ManualNews />
      {me.config.type === CustomerType.BESS && featureFlag('records') && (
        <NewReports />
      )}
    </div>
  );
}
